import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import styles from './MerchantProfil.module.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const Localisation = ({ company, lat, lon }) => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Localisation</h1>
            <div className={styles.map}>
                <MapContainer
                    center={[lat, lon]}
                    zoom={13}
                    style={{ height: "100%", width: "100%" }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    />

                    <Marker position={[parseFloat(lat), parseFloat(lon)]}>
                        <Popup>{company}</Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
};

export default Localisation;